import React, { useState } from 'react';
import { Popover } from "react-tiny-popover";
import { 
  SortIconRentCe, 
  SortIconRentDec, 
  RatingIconRent, 
  ArrowIconRent 
} from "../../AssetComponents/Images";
import { useOnboarding } from './OnBoarding1';

function Listings1({ onSort, setSortType, filteredProperties }) {
  const [showOrderMenu, setShowOrderMenu] = useState(false);
  const [currentSort, setCurrentSort] = useState('Sort');
  const [isLoading, setIsLoading] = useState(false);
  const { isOnboarding, currentStep } = useOnboarding();

  // Add highlighting during onboarding step 2 (sort listings step)
  const isHighlighted = isOnboarding && currentStep === 2;

  return (
    <div className="relative"> {/* Add wrapper for positioning */}
      <Popover
        isOpen={showOrderMenu}
        positions={["bottom"]}
        onClickOutside={() => setShowOrderMenu(false)}
        content={
          <div
            className="mt-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,257,0.8)]"
          >
            <div 
              onClick={() => {
                setCurrentSort('Price: Low to High');
                setShowOrderMenu(false);
              }} 
              className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
            >
              <SortIconRentCe />
              <div className="text-[#666666]">Price: Low to High</div>
            </div>
            <div 
              onClick={() => {
                setCurrentSort('Price: High to Low');
                setShowOrderMenu(false);
              }} 
              className="cursor-pointer hover:bg-[#f5f5f5] p-[8px] gap-[8px] flex items-center w-full"
            >
              <SortIconRentDec />
              <div className="text-[#666666]">Price: High to Low</div>
            </div>
            <div 
              onClick={() => {
                setCurrentSort('Rating');
                setShowOrderMenu(false);
              }} 
              className="cursor-pointer hover:bg-[#f5f5f5] rounded-b-[10px] p-[8px] gap-[8px] flex items-center w-full"
            >
              <RatingIconRent />
              <div className="text-[#666666]">Rating</div>
            </div>
          </div>
        }
      >
        <div
          onClick={() => setShowOrderMenu(!showOrderMenu)}
          className={`${isHighlighted ? 'onboarding-highlight' : ''} py-[4px] cursor-pointer rounded-[10px] px-[14px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,257,0.8)] ${
            isHighlighted 
              ? 'bg-white border-2 border-purple-500 ring-4 ring-purple-300 animate-pulse' 
              : 'bg-white hover:bg-[#f6f6f6]'
          }`}
          style={{ minWidth: 'fit-content', maxWidth: '100px' }}
        >
          <div className="text-[#5b1dee] font-semibold">
            {isLoading ? 'Loading...' : currentSort}
          </div>
          <ArrowIconRent />
        </div>
      </Popover>
    </div>
  );
}

export default Listings1;